import React, { useEffect } from 'react'
import TeamMembersTable from './TeamMembersTable'
import { useQuery } from '@apollo/client';
import { getTeamNameQuery, getAssociationPublicQuery, getTeamQuery, statOrdersByTeamQuery, getDashboardAssociationBookletsQuery } from '../../../queries/queries';
import { Button, PageHeader } from '../../../common/index'
import { useNavigationContext } from '../../../context/NavigationContext';
import { useHistory } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa6';
import DashboardTeamSend from './DashboardSend';
import CountUp from 'react-countup';

function DashboardTeam(props) {
  const { association: associationId, team: teamId } = props.match.params;
  const { data: associationData } = useQuery(getAssociationPublicQuery, { variables: { associationId: associationId } })
  const { data: teamName } = useQuery(getTeamNameQuery, { variables: { teamId: teamId } })
  const { data: teamData } = useQuery(getTeamQuery, { variables: { teamId: teamId } })
  const { data: bookletsData } = useQuery(getDashboardAssociationBookletsQuery, {
    variables: { associationId: associationId, teamId: teamId }
  });

  // Create default booklet from association booklets (same logic as DashboardTeamContext)
  const associationBooklets = bookletsData?.booklets || [];
  const defaultBooklet = associationBooklets
    .filter((booklet) => booklet.validFrom)
    .sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime())[0];

  const { data: statsData } = useQuery(statOrdersByTeamQuery, {
    variables: {
      teamId: teamId,
      bookletId: defaultBooklet?._id || null,
      fromDate: null,
      toDate: null
    },
    skip: !defaultBooklet
  });
  const history = useHistory();

  const { setNavigationActivated } = useNavigationContext();
  useEffect(() => {
    setNavigationActivated(true);
  }, [setNavigationActivated]);

  const possessionType = JSON.parse(localStorage.getItem('POSSESSION'))?.type;
  const subshopVisibility = associationData?.association?.subshopVisibilityInDashboard;
  const shouldShowTeamMembers = subshopVisibility === 'TEAM_MEMBERS' || subshopVisibility === 'TEAMS_AND_MEMBERS';

  return (
    <div id="dashboard" className="teams">
      <PageHeader>
        {possessionType === 'team' ? (
          <>
            <h1>Bjud in säljare</h1>
            <p>Skicka denna information till dina medlemmar och uppmana dem att registrera sina medlemsshoppar.</p>
          </>
        ) : (
          <div className="max-w flex">
            <Button
              className="btn secondary"
              onClick={() => history.goBack()}
            >
              <div className="flex items-center justify-center">
                <FaChevronLeft size={14} />
                <span>Tillbaka</span>
              </div>
            </Button>
          </div>
        )}
      </PageHeader>
      <div className="container flex justify-center">
        <div className="dashboard-table-container md">
          {possessionType === 'team' ? (
            <DashboardTeamSend
              associationId={associationId}
              teamId={teamId}
            />
          ) : (
            <div className="team-stats-card">
              <div className="team-header">
                <h3>{teamName?.name}</h3>
                <p>{teamData?.team?.adminEmails?.[0] || 'Ingen e-post registrerad'}</p>
              </div>
              <div className="stats-row">
                <div className="stat-box">
                  <div className="stat-label">Förtjänst</div>
                  <div className="stat-value">
                    {/* @ts-ignore */}
                    <CountUp end={statsData?.orders?.webshopEarnings || 0} />
                    <span>kr</span>
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-label">Sålda häften</div>
                  <div className="stat-value">
                    {/* @ts-ignore */}
                    <CountUp end={statsData?.orders?.webshopOrders?.length || 0} />
                    <span>st</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {shouldShowTeamMembers && (
            <TeamMembersTable
              associationId={associationId}
              teamName={teamName}
              teamId={teamId}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default DashboardTeam
